export default "__VITE_ASSET__3293a920__"